import {
	createContext,
	ReactNode,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import * as Sentry from '@sentry/capacitor';
import { getAuth } from 'firebase/auth';

import { useBusinessLayer } from '@mopla/business-logic';

export const EmergencyStatusContext = createContext({
	hasOngoingEmergency: false,
	toggleEmergency: (status: boolean) => {
		return;
	},
});

const EmergencyStatusProvider = ({ children }: { children: ReactNode }) => {
	const { api } = useBusinessLayer();

	const [hasOngoingEmergency, setHasOngoingEmergency] = useState(false);
	const toggleEmergency = useCallback((status: boolean) => {
		setHasOngoingEmergency(status);
	}, []);
	const value = useMemo(
		() => ({ hasOngoingEmergency, toggleEmergency }),
		[hasOngoingEmergency, toggleEmergency]
	);

	useEffect(() => {
		getAuth().onAuthStateChanged((user) => {
			if (user) {
				api
					.get('/api/drivers/emergencyCall')
					.then((res: 'ACTIVATED' | 'DEACTIVATED' | 'OFF') =>
						setHasOngoingEmergency(res === 'ACTIVATED')
					)
					.catch((err: unknown) => Sentry.captureException(err));
			}
		});
	}, []);

	return (
		<EmergencyStatusContext.Provider value={value}>
			{children}
		</EmergencyStatusContext.Provider>
	);
};

export default EmergencyStatusProvider;
